import React, { useReducer } from 'react';
import { RegistrationContext } from './registrationContext';
import { reducer } from '@/hooks/registration/registrationReducer';
import { defaultState } from '@/hooks/registration/registrationInitialState';

export const RegistrationProvider = ({ children }: { children: React.ReactNode }) => {
    const [state, dispatch] = useReducer(reducer, defaultState);
    return <RegistrationContext.Provider value={{ state, dispatch }}>{children}</RegistrationContext.Provider>;
};
